module.exports = __webpack_public_path__ + "img/man-avatar.3708e7bd.png";